import $ from 'jquery';

export default class Video {
  constructor() {
    const $videoContainer = $('#video_container');
    const $videoTitle = $('#video_title');

    $('[data-video-id]').on('click', function () {
      const $this = $(this);
      const id = $this.data('video-id');
      $videoContainer
        .html('<b>Loading...</b>')
        .load(
          '/system/ajax_handlers/site.video.server.php',
          { video_id: id },
          () => {
            // additional callback for facebook videos
            if (window.hasOwnProperty('FB') && window.FB !== null && window.FB.hasOwnProperty('XFBML')) {
              window.FB.XFBML.parse();
            }

            // reset previous selected row:
            $('div.video_list_row_wrapper_selected')
              .removeClass('video_list_row_wrapper_selected')
              .addClass('video_list_row_wrapper');

            // highlight the selected row
            $(`#row_${id}`)
              .removeClass('video_list_row_wrapper')
              .addClass('video_list_row_wrapper_selected');

            // change video title
            $videoTitle.html($this.data('title'));
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./vively/scripts/components/videos.js